import _classCallCheck from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/createClass";

var Chronus =
/*#__PURE__*/
function () {
  function Chronus() {
    _classCallCheck(this, Chronus);

    this.timeDifferences = [];
    this.averageTimeDifference = 0;
  }

  _createClass(Chronus, [{
    key: "register",
    value: function register(timestamp) {
      this.timeDifferences.push(Date.now() - timestamp);

      while (this.timeDifferences.length > 20) {
        this.timeDifferences.shift();
      }

      var total = 0;

      for (var i = 0; i < this.timeDifferences.length; i++) {
        total += this.timeDifferences[i];
      }

      this.averageTimeDifference = total / this.timeDifferences.length;
    }
  }]);

  return Chronus;
}();

export default Chronus;